import { render } from "./IpromiseLeague.vue?vue&type=template&id=4fdb88b1&scoped=true"
import script from "./IpromiseLeague.vue?vue&type=script&lang=js"
export * from "./IpromiseLeague.vue?vue&type=script&lang=js"

import "./IpromiseLeague.vue?vue&type=style&index=0&id=4fdb88b1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fdb88b1"]])

export default __exports__